<template>
    <div class="view-container">
        <div id="snackbar">{{ $t('Copied') }}</div>
        <div id="progress-snackbar" class="snack">
            <div class="progress-container vertical" style="min-width: 30vw;">
                <ProgressBar :loaded="bytesReceived" :total="bytesToReceive"/>
            </div>
        </div>
        <h3>{{ $t('CRFIVersions') }}</h3>
        <div class="vertical">
            <div class="horizontal">
                <div class="selection-section">
                    <h5 style="color: white;">{{ $t('Platform') }}</h5>
                    <check-box-crfi v-for="platform in platforms" :key="platform" :checkbox-error="''" :noMargin="true" :label="platform" :no-margin="true" :no-padding="true" @onChange="changePlatform(platform)"/>
                </div>
                <div class="selection-section">
                    <h5 style="color: white;">{{ $t('Requirements') }}</h5>
                    <check-box-crfi v-for="req in requirementNames" :key="req" :checkbox-error="''" :noMargin="true" :label="req" :no-margin="true" :no-padding="true" @onChange="changeRequirementSelection(req)"/>
                </div>
            </div>
            <div>
                <Button buttonClass='save-button semi-bold w-100' :title="$t('DownloadPack')"></Button>
            </div>
        </div>
        <hr/>
        <h3>{{ $t('Components') }}</h3>
        <div class="horizontal">
            <Button buttonClass='save-button semi-bold w-100' :title="$t('DownloadWSS')" @onClick="downloadLatest('WSS')"/>
            <Button buttonClass='save-button semi-bold w-100' :title="$t('DownloadLTC')" @onClick="downloadLatest('LTC')"/>
            <Button buttonClass='save-button semi-bold w-100' :title="$t('DownloadBlackBox')" @onClick="downloadLatest('BlackBox')"/>
        </div>
    </div>
</template>

<script>
import { getRequirementsList, getSoftwarePlatforms, getVersionsOverview, getVersionById } from '../../api/api';
import Button from '../../components/Button.vue';
import CheckBoxCrfi from '../../components/CheckBoxCrfi.vue';
import ProgressBar from '../../components/ProgressBar.vue';
import { parseProgress } from '../../util/progress';

var context;

export default {
    components: { Button, CheckBoxCrfi, ProgressBar },
    data() {
        return {
            platforms: [],
            requirementNames: [],
            requirements: [],
            selectionsRequirements: [],
            // progress
            bytesReceived: 0,
            bytesToReceive: 0,
        }
    },
    methods: {
        async getData() {
            this.platforms = await getSoftwarePlatforms();
            this.products = await getVersionsOverview();
            this.requirements = await getRequirementsList();
            this.requirementNames = this.getNewest(this.requirements);
        },
        compareVersions(v1, v2) {
            if (v1 == '' || v1 == null || v2 == '' || v2 == null) {
                return 0;
            }

            var v1Parts = v1.split('.');
            var v2Parts = v2.split('.');

            var len = v1Parts.length() < v2Parts.length() ? v1Parts.length() : v2Parts.length();

            for (var i = 0; i < len; i++) {
                if (v1Parts[i] != v2Parts[i]) {
                    if (v1Parts[i] > v2Parts[i]) {
                        return 1;
                    }
                    return -1;
                }
            }

            return v1Parts.length() > v2Parts.length() ? 1 : -1;
        },
        getNewest(data) {
            return [...new Set(data.map(item => item.program))];
        },
        downloadLatest(product) {
            console.table(this.products)
            var productList = this.products.filter(x => x.platform == product);

            console.table(productList)

            if (productList.length == 0) {
                var x = document.getElementById("snackbar");
                x.className = "show";
                x.innerHTML = `${this.$i18n.t('NotFound')} - ${product}`
                setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
                return;
            }

            if (productList.length > 1) {
                productList = productList.sort((a, b) => this.compareVersions(a.softwareVersion, b.softwareVersion))
            } 

            var objectToDownload = productList[0];
            this.downloadVersion(objectToDownload.id, objectToDownload.fileName, objectToDownload.fileSize)
        },
        async downloadVersion(id, fileName, knownSize = 0) {
            var x = document.getElementById("progress-snackbar");
            x.className = "snack show";
            this.bytesReceived = 0;
            this.bytesToReceive = 0;

            var followConfig = {
                onDownloadProgress: progressEvent => {
                    const { loaded, total } = parseProgress(progressEvent, knownSize);
                    context.bytesReceived = loaded;
                    context.bytesToReceive = total;
                }
            };

            var blob = await getVersionById(id, followConfig);
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";

            var url = window.URL.createObjectURL(blob.data);
            a.href = url;
            a.download = fileName; 
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();

            setTimeout(function(){ x.className = x.className.replace(" show", ""); }, 1000);
        },
        changeRequirementSelection(req) {

        },
        changePlatform(platform) {

        }
    },
    mounted: async function() {
        context = this; 

        this.getData();
    }
}
</script>

<style>
.save-button {
    margin-right: 10px;
}

label.mt-4 {
    margin-top: 0 !important;
}

.selection-section {
    background-color: #414F51; 
    border: 1px solid white; 
    border-radius: 5px; 
    padding: 10px 20px; 
    margin: 5px 10px 5px 0;
}

.progress-container {
    margin: 10px 20px;
}

#upload-progress {
    height: 20px;
    border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/Software/SoftwareMain.vue